import { atom } from "recoil";
import { localStorageEffect } from "../localStorage/localStorageEffect";
import { MOBILE_VIEW_TYPE, mobileViewType } from "../../types/main";

export type ViewModeType = "calendar" | "wiki";

export const viewModeState = atom<ViewModeType>({
  key: "viewModeState",
  default: "calendar",
});

export const selectedWikiSpaceState = atom<number | null>({
  key: "selectedWikiSpaceState",
  default: null,
});

export const mobileViewState = atom<mobileViewType>({
  key: "mobileViewState",
  default: MOBILE_VIEW_TYPE.INBOX,
  effects: [localStorageEffect<mobileViewType>("mobileView", MOBILE_VIEW_TYPE.INBOX)],
});
